// extracted by mini-css-extract-plugin
export default {"zoomModal":"r0-z"};